/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyDetail } from '../../models/company-detail';

export interface GetCompany$Params {

/**
 * ID spoločnosti
 */
  id: number;
}

export function getCompany(http: HttpClient, rootUrl: string, params: GetCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyDetail>> {
  const rb = new RequestBuilder(rootUrl, getCompany.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompanyDetail>;
    })
  );
}

getCompany.PATH = '/admin/companies/{id}';
